// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import store from './store'
import globalConfig from '@/utils/globalConfig'
import VueClipboard from 'vue-clipboard2'
import 'babel-polyfill'

// 引入element-ui
Vue.use(ElementUI, {
  size: 'medium'
})
Vue.use(globalConfig)
Vue.use(VueClipboard)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js